import React from 'react'

function ConfirmationPopUp({ setIsConfirmPopUp, handleOnSubmitAttendance }) {
    return (
        <div className=" successful_create_transprant_body ">
            <div className=" p-2 successful_create_container shadow" style={{ minHeight: "30vh" }}>
                <span className=" my-4 successfully_create_message">
                    Are you sure you want to submit attendance?
                </span>
                <div className='flex gap-20'>
                    <button
                        onClick={() => {
                            handleOnSubmitAttendance()
                            setIsConfirmPopUp(false)
                        }}
                        className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
                    >
                        Yes
                    </button>
                    <button
                        onClick={() => setIsConfirmPopUp(false)}
                        className="btn btn-danger px-4 py-2 "
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationPopUp